/* eslint-disable react-hooks/rules-of-hooks */
import styled from '@emotion/styled'
import { Shapes, Typographies, useTypography } from 'src/components/theme'

export const SubscriptionModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${Shapes.spacing[4]}px;
  button {
    flex: 1;
    ${useTypography(Typographies.title2)}
    height: ${Shapes.spacing[7]}px;
    padding-inline: ${Shapes.spacing[4]}px;
  }
`
